import { render, staticRenderFns } from "./gridDetail.vue?vue&type=template&id=512bab52&scoped=true&"
import script from "./gridDetail.vue?vue&type=script&lang=js&"
export * from "./gridDetail.vue?vue&type=script&lang=js&"
import style0 from "./gridDetail.vue?vue&type=style&index=0&id=512bab52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512bab52",
  null
  
)

export default component.exports